// Teardown de sessão no logout. Ao contrário de auth-storage.ts (só leitura, o
// Angular é dono da escrita no login/refresh), este módulo é o único ponto em
// que o React escreve no storage de sessão — e só para destruí-lo.
//
// Espelha o efeito observável de AuthService.logout() sem depender dele: aquele
// método fazia limparCapabilitiesPrivadas() (estado em memória do Angular,
// descartado ao desmontar a folha), sessionStorage.clear() e deleteCookieLocal()
// (que apenas remove a chave 'LOCAL' do sessionStorage — coberta pelo clear()).
// localStorage é preservado de propósito: o locale sobrevive ao logout, como no
// legado.

/** Encerra a sessão limpando o sessionStorage compartilhado; nunca lança. */
export function clearSession(): void {
  try {
    sessionStorage.clear();
  } catch {
    // Storage inacessível (modo restrito do browser): não há sessão a limpar e o
    // logout não deve quebrar por causa disso.
  }
}
